import { GridColumnType } from "../../../../data/gridColumnType";

export const RequirementListingConfig = {
  columns: [
    {
      name: "Channel",
      fieldName: "channelName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Requirement Name",
      fieldName: "requirementName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Status",
      fieldName: "status",
      colType: GridColumnType.Text,
    },
    {
      name: "Action",
      fieldName: "action",
      allowShort: false,
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: false,
        allowDelete: false,
      },
      customAction: [
        {
          name: "Edit",
          // iconName: AppIcons.copyIcon,
          onViewAction: (data) => {
            alert("called permissions");
          },
        },
      ],
    },
  ],
};
